import * as types from './actionTypes';

export function ArmazenaProtocoloActionsSuccess(protocolo) {
    
    return { type: types.ARMAZENA_PROTOCOLO, protocolo }
}

export function ArmazenaProtocolo(protocolo) {
    
    return function (dispatch) {
        return dispatch(ArmazenaProtocoloActionsSuccess(protocolo));
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/armazenaProtocoloActions.js
 **/